import React from "react";
import Moment from "moment";
import useApi, { doFetch } from "storybook-dashboard/utils/fetching";
import { downloadS3Object } from "./reportDocumentRow";
import ReportRowErrorBoundary from "./error";
import { confirmDelete } from "traec-react/utils/sweetalert";
import Octicon from "react-octicon";
import { Hider } from "storybook-dashboard/utils";

export const deleteDocumentObject = ({ trackerId, commitId, docId, docObjectId, trigger }) => {
  confirmDelete({
    text: `This will delete the document object and all associated upload data.\n\n Are you sure you would like to proceed?`,
    onConfirm: () => {
      doFetch(`/api/tracker/${trackerId}/commit/${commitId}/document/${docId}/object/${docObjectId}/`, "DELETE").then(
        (r) => trigger()
      );
    },
  });
};

function DocumentHistoryRow(props) {
  let { indentLevel, docObj, commit, disableInputs } = props;

  if (!docObj) {
    return null;
  }

  let filename = docObj.get("filename");
  let is_staging = commit ? commit.get("is_staging") || commit.getIn(["status", "name"]) === "Requires Revision" : null;

  return (
    <tr>
      <td>
        <a
          style={{
            cursor: "pointer",
            color: "rgb(0, 123, 255)",
            textDecoration: "underline",
          }}
          onClick={(e) => {
            e.preventDefault();
            downloadS3Object({ ...props, currentDocObject: docObj });
          }}
        >
          {filename}
        </a>
      </td>
      {/* <td>
        <p style={{ margin: "0", marginLeft: `${(indentLevel + 1) * 1.5}em` }}>
          {Moment(docObj.get("created")).format("Do MMM YY, h:mm:ss a")}
        </p>
      </td> */}
      <td className="text-right">
        <Hider hide={!is_staging || disableInputs}>
          <div>
            <span
              className="text-danger cursor-pointer"
              onClick={(e) => deleteDocumentObject({ ...props, docObjectId: docObj.get("uid") })}
            >
              <Octicon name="trashcan" />
            </span>
          </div>
        </Hider>
      </td>
    </tr>
  );
}

function NoRevisionsMessage() {
  return (
    <tr>
      <td colSpan={7} style={{ textAlign: "center" }}>
        <i>No uploads for this file</i>
      </td>
    </tr>
  );
}

export default function DocumentHistoryRows(props) {
  let { hide, trackerId, commitId, docId } = props;
  let { data: docObjects, trigger } = useApi(
    "/api/tracker/{trackerId}/commit/{commitId}/document/{docId}/object/?thisCommitOnly=true",
    {
      trackerId,
      commitId,
      docId,
    }
  );

  if (hide) return null;

  let filteredAndSortedDocObjects = docObjects.sortBy((i) => i.get("created")).reverse();

  if (!filteredAndSortedDocObjects?.size) {
    return <NoRevisionsMessage />;
  }

  return filteredAndSortedDocObjects.map((obj, i) => (
    <ReportRowErrorBoundary key={i}>
      <DocumentHistoryRow {...props} docObj={obj} trigger={trigger} />
    </ReportRowErrorBoundary>
  ));
}
